import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { authSlice } from './authSlice';
import { moveReducer } from './move';
import { packingReducer } from './packing';
import { putawayReducer } from './putaway';
var store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        move: moveReducer,
        packing: packingReducer,
        putaway: putawayReducer
    },
    middleware: getDefaultMiddleware({
        serializableCheck: false
    })
});
export default store;
